<p-dialog
  (onHide)="visibleChange.emit(false)"
  [closable]="closable()"
  [modal]="true"
  [style]="{ width: width(), height: height() }"
  [visible]="visible()">

  <ng-template #header>
    <div class="header-title-dialog">{{ headerTitle() }}</div>
  </ng-template>

  <ng-content>
    <div class="break-words">
      {{ message() }}
    </div>
  </ng-content>

  <ng-template #footer>
    <p-button (click)="onClickCancel()"
        (keydown.enter)="$event.preventDefault(); onClickCancel()"
        (keydown.space)="$event.preventDefault(); onClickCancel()" [label]="cancelLabel()" styleClass="btn-outlined"></p-button>
    <p-button (click)="onClickConfirm()"
        (keydown.enter)="$event.preventDefault(); onClickConfirm()"
        (keydown.space)="$event.preventDefault(); onClickConfirm()" [label]="confirmLabel()" styleClass="btn-red"></p-button>
  </ng-template>
</p-dialog>
